import React, { memo } from "react";
import { Link, useLocation } from "react-router-dom";

const ParamsLink = memo(({ children, to, className = "", deleteParams = [], additionalParams = {}, ...props }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Delete specified query parameters
  deleteParams.forEach((param) => {
    queryParams.delete(param);
  });

  // Add additional parameters
  Object.keys(additionalParams).forEach((param) => {
    queryParams.set(param, additionalParams[param]);
  });

  return (
    <Link
      to={{
        pathname: to,
        search: queryParams.toString() ? `?${queryParams.toString()}` : "",
      }}
      className={className}
      {...props}
    >
      {children}
    </Link>
  );
});

export default ParamsLink;
